import styled, { css, keyframes } from 'styled-components';

const skins = {
  white: 'white',
  primary: 'primary900',
};

const textSkin = ({ skin }) => {
  const color = skins[skin] || skins['primary'];
  return css`
    color: ${(props) =>
      props.theme.base.colorSchema[color] ? props.theme.base.colorSchema[color] : color};
  `;
};

const loaderSkin = ({ skin }) => {
  const color = skins[skin] || skins['primary'];

  return css`
    background: ${(props) =>
      props.theme.base.colorSchema[color] ? props.theme.base.colorSchema[color] : color};
    }

    &:before,
    &:after {
      background: ${(props) =>
        props.theme.base.colorSchema[color] ? props.theme.base.colorSchema[color] : color};
    }

  `;
};

export const StyledLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 9px;
  height: 100%;
  width: 100%;
`;

export const StyledLoaderText = styled.div`
  ${textSkin};
  font-weight: bolder;
  margin: 0 0 0 20px;
  flex: 1;
`;

const loadAnimation = keyframes`
 0%,
    40% {
      height: 1em;
    }
    80%,
    100% {
      height: 1.8em;
    }
`;

const loadAnimationRules = css`
  ${loadAnimation} 1s infinite ease-in-out;
`;

export const StyledLoaderAnimation = styled.div`
  ${loaderSkin};
  width: 1em;
  height: 1em;
  font-size: 6px;
  animation: ${loadAnimationRules};
  position: relative;
  animation-delay: -0.16s;
  &:before,
  &:after {
    width: 1em;
    height: 1em;
    font-size: 6px;
    animation: ${loadAnimationRules};
  }

  &:before {
    position: absolute;
    left: -1.5em;
    animation-delay: -0.35s;
    margin: auto 0;
    bottom: 0;
    top: 0;
    content: '';
  }

  &:after {
    position: absolute;
    left: 1.5em;
    margin: auto 0;
    bottom: 0;
    top: 0;
    content: '';
    animation-delay: -0.77s;
  }
`;
